import { Tin } from "./Tin";
import { DateTime } from "luxon";
const FORMAT_PATTERN = /^[0-9]{6}-?[0-9]{4}$/;
export class DanishTin extends Tin {
    validate(tin) {
        return (typeof tin !== "undefined" &&
            this.hasValidFormat(tin) &&
            this.hasValidDate(tin) &&
            this.hasValidChecksum(tin));
    }
    hasValidDate(tin) {
        return DateTime.fromFormat(tin.substr(0, 6), "ddMMyy").isValid;
    }
    hasValidFormat(tin) {
        return FORMAT_PATTERN.test(tin);
    }
    hasValidChecksum(tin) {
        tin = tin.replace("-", "");
        const dayOfBirth = parseInt(tin.substr(0, 2), 10);
        const monthOfBirth = parseInt(tin.substr(2, 2), 10);
        const yearOfBirth = parseInt(tin.substr(4, 2), 10);
        const serialNumber = parseInt(tin.substr(-4), 10);
        if (dayOfBirth === 1 && monthOfBirth === 1) {
            return true;
        }
        if (yearOfBirth >= 37 &&
            yearOfBirth <= 57 &&
            serialNumber >= 5000 &&
            serialNumber <= 8999) {
            return false;
        }
        else {
            const sum = +tin[0] * 4 +
                +tin[1] * 3 +
                +tin[2] * 2 +
                +tin[3] * 7 +
                +tin[4] * 6 +
                +tin[5] * 5 +
                +tin[6] * 4 +
                +tin[7] * 3 +
                +tin[8] * 2;
            const remainderMod11 = sum % 11;
            if (remainderMod11 === 1) {
                return false;
            }
            else if (remainderMod11 === 0) {
                return +tin[9] === 0;
            }
            else {
                return +tin[9] === 11 - remainderMod11;
            }
        }
    }
    getNormalizedTin() {
        const baseTin = this.tin.replace("-", "");
        return `${baseTin.substr(0, 6)}-${baseTin.substr(6, 9)}`;
    }
    getBirthDate() {
        if (!this.hasValidDate(this.tin)) {
            return undefined;
        }
        const year = parseInt(this.tin.substr(4, 2), 10);
        const seventh = parseInt(this.getNormalizedTin().substr(7, 1), 10);
        let century = "19";
        if (seventh === 4) {
            if (year <= 36) {
                century = "20";
            }
        }
        else if (seventh >= 5 && seventh <= 8) {
            if (year <= 57) {
                century = "20";
            }
            else {
                century = "18";
            }
        }
        else if (seventh === 9) {
            if (year <= 36) {
                century = "20";
            }
        }
        const danishDate = this.tin.substr(0, 4) + century + this.tin.substr(4, 2);
        return DateTime.fromFormat(danishDate, "ddMMyyyy").toFormat("yyyy-MM-dd");
    }
}
